import { render, staticRenderFns } from "./IconCameraOutline.vue?vue&type=template&id=2c4a009f"
import script from "./IconCameraOutline.vue?vue&type=script&lang=js"
export * from "./IconCameraOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports